import type { LoginMethodType } from '../types';

export const authMethodPriority: LoginMethodType[] = [
  'password',
  'email_code',
  'sms_code',
  'google',
  'azure',
  'okta',
];
